"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var storybook_1 = require("@eyecons/storybook");
var ra_fetch_1 = require("ra-fetch");
function initVideoParams(channel_id, query) {
    var params = {
        channel_id: channel_id,
        sort: ['starred desc', 'created_at desc'],
        type: ['vod', 'event'],
        tags: true,
        children: true,
        paginate: 12,
        resource: 'VideoFull',
    };
    if (query) {
        params.category = query.category;
        params.team = query.team;
    }
    return params;
}
function initLivestreamParams(channel_id) {
    return {
        channel_id: channel_id,
        sort: 'created_at desc',
        tags: true,
        type: 'live',
        children: true,
        paginate: 4,
        details: true,
        resource: 'VideoFull',
    };
}
function Channel(_a) {
    var channel = _a.channel, query = _a.query, user = _a.user, _b = _a.firebase_supported, firebase_supported = _b === void 0 ? false : _b, firebase_token = _a.firebase_token, requestFirebaseToken = _a.requestFirebaseToken;
    var _c = ra_fetch_1.useApi('backend')
        .index('public.videos', initVideoParams(channel.id, query)), videos = _c[0], setVideos = _c[1], params = _c[2], setParams = _c[3];
    var _d = ra_fetch_1.useApi('backend')
        .index('public.videos', initLivestreamParams(channel.id)), livestreams = _d[0], setLivestreams = _d[1], livestreamParams = _d[2], setLivestreamParams = _d[3];
    if (channel.loading) {
        return react_1.default.createElement(storybook_1.Icons.Icon, { name: 'loader' });
    }
    if (!channel.id) {
        return react_1.default.createElement(storybook_1.Pages.Dashboard.NotFound, null);
    }
    react_1.useEffect(function () {
        if (!videos.loading) {
            setParams(__assign(__assign({}, params), { channel_id: channel.id }));
        }
        if (!livestreams.loading) {
            setLivestreamParams(__assign(__assign({}, livestreamParams), { channel_id: channel.id }));
        }
    }, [channel.id]);
    return react_1.default.createElement("div", { className: 'storybook-pages-channel' },
        react_1.default.createElement(storybook_1.Channels.Hero, { channel: channel, user: user, firebase_supported: firebase_supported, firebase_token: firebase_token, requestFirebaseToken: requestFirebaseToken }),
        Boolean(livestreams.data.length) && react_1.default.createElement(storybook_1.Channels.Livestreams, { livestreams: livestreams.data }),
        react_1.default.createElement(storybook_1.Channels.Videos, { videoParams: params, setVideoParams: setParams, videos: videos, channel: channel }));
}
exports.default = Channel;
